var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4723 34.8604C11.0323 34.8604 5.59235 34.8604 0.152344 34.8604C0.152344 23.5384 0.152344 12.1824 0.152344 0.860413C11.4743 0.860413 22.8304 0.860413 34.1524 0.860413C34.1524 12.1824 34.1524 23.5384 34.1524 34.8604C28.8144 34.8604 23.5104 34.8604 18.1723 34.8604C18.1723 32.9564 18.1723 31.0524 18.1723 29.0124C21.6064 29.0124 24.8704 29.0124 28.2024 29.0124C28.2024 21.5664 28.2024 14.2904 28.2024 6.94641C27.8624 6.87841 27.5224 6.77641 27.2164 6.74241C20.5864 6.74241 13.9563 6.74241 7.36035 6.70841C6.23835 6.70841 6.06835 7.21841 6.06835 8.17041C6.10235 14.6644 6.06835 21.1924 6.06835 27.6864C6.06835 28.0604 6.17035 28.4344 6.23835 29.0464C9.63835 29.0464 13.0043 29.0464 16.4723 29.0464C16.4723 31.1544 16.4723 32.9904 16.4723 34.8604Z",
    fill: "#4C4C50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/square.1d86f03888495a1505de23f21f7feaa4.svg";
export { ForwardRef as ReactComponent };